/**
 * Funcion que dado un valor, si es blanco o con caracteres vacios retorna nulo,
 * caso contrario el valor con trim de espacios delante y atras
 * @param value
 */
export function trimOrNull(value: string | null | undefined): string | null {
  if (!value) return null;
  const t = value.trim();
  if (t.length === 0) return null;
  return t;
}
/**
 * Funcion que dado un string, Capitaliza la primer letra el mismo
 * @param value {string} - String a capitalizar
 */
export function capitalize(s: string) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}